<template>
  <div class="viewurl-page-table">

		<div class="lowpriced-page-table">
      <div class="searchwrap">
        <el-row :gutter="0">
          <el-col :span="17">
            <el-form :inline="true" class="table-form-inline search-left">
              <el-form-item v-for="(items, index) in selectors.slice(0, 3)" :key="'select' + index" :label="items.label">
                <el-select v-model="items.default" :placeholder="$t('dsfx.t14')" size="mini" @change="changeSelector(items.action)">
                  <el-option
                    v-for="item in items.options"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('report.s58')" class="switch-check">
                <el-switch
                  v-model="lowpricechk"
                  active-value="1"
                  inactive-value="2"
                  active-color="#13ce66"
                  inactive-color="#9d9d9d"
                  @change="showLowprice">
                </el-switch>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="7">
            <div class="tousuxiajiabuttonwrap">
              <el-input 
                v-model="keywords" 
                :placeholder="$t('jgjk.s2651')" 
                size="mini" 
                @keyup.enter.native="loadTables(page.page, page.size, 50)"
              >
              </el-input>
              <el-button type="danger" @click="loadTables(page.page, page.size, 50)" size="mini">{{ $t('dsfx.t26') }}</el-button>
            </div>
          </el-col>
        </el-row>
      </div>

      <PriceMonitoringTable 
        :tableData="tableData"
        :tableloading="tableloading"
        :pagetotal="pagetotal"
        :showtradeamount="false"
        :setDefaultSort="{prop: 'MarginPercent', order: 'ascending'}"
        :page="page"
      />

    </div>

  </div>
</template>

<script>
import PriceMonitoringTable from '@/components/Commons/PriceMonitoringTable.vue'
export default {
  components: {
    PriceMonitoringTable
  },
  data(){
    return{
      current: this.getCurrentInfo(),
      selectors: [{
        label: this.$t('jgjk.s12'),
        options: [],
        default: '',
        action: 'channel'
      },{
        label: this.$t('dsfx.t23'),
        options: [{
          name: this.$t('tabletabs.all'),
          value: ''
        },{
          name: this.$t('dsfx.t53'),
          value: 0,
        },{
          name: this.$t('dsfx.t52'),
          value: 1,
        }],
        default: '',
        action: 'authorize'
      },{
        label: this.$t('jgjk.s230'),
        options: [{
          name: this.$t('tabletabs.all'),
          value: ''
        },{
          name: this.$t('jgjk.s231'),
          value: 1,
        },{
          name: this.$t('jgjk.s232'),
          value: 0,
        }],
        default: '',
        action: 'discrepancy'
      }],
      lowpricechk: JSON.parse(localStorage.getItem("lowpricechk")) != null 
                && JSON.parse(localStorage.getItem("lowpricechk")) != undefined 
                && JSON.parse(localStorage.getItem("lowpricechk")) != '' 
                ? JSON.parse(localStorage.getItem("lowpricechk")).val : '2',
      stocknumchk: 1,
      keywords: '',
      tableloading: false,
      tableData: [],
      pagetotal: 0,
      page: {
        size: 25,
        page: 1
      }
    }
  },

  mounted(){
    let that = this
    that.getChannels()
    that.loadTables(that.page.page, that.page.size, 50)
  },

  methods: {

    /**
     * 选择条件筛选
     */
    changeSelector: function(){
      let that = this
      that.loadTables(that.page.page, that.page.size, 50)
    },

    /**
     * 获取渠道列表
     */
    getChannels: function(){
      let that = this
      let url = that.API_URL + '/v3/price/statistics/filter'
      let data = {
        skuid: '',
        taskid: that.current.taskid,
        channel: '',
        authorize: '',
        search: '',
      }
      $.ajax({
        url:  url,
        type: "GET",
        data: data,
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(response) {
          let _all = {
            name : that.$t('tabletabs.all'),
            value : ''
          }
          that.selectors[0].options = response.results[1].map(function(val){
            return {
              name: that.setChannel(val.Channel).loc,
              value: val.Channel
            }
          })
          that.selectors[0].options.unshift(_all)
        },
        error: function(errors) {
          console.log('getChannels', errors)
        }
      })      
    },

    /**
     * 显示低价/全部
     */
    showLowprice: function(val){
      let that = this
      this.setLocalStorage( "lowpricechk", val)
      that.loadTables(that.page.page, that.page.size, 50)
    },

    /**
     * 显示零库存
     */
    showZerostock: function(){
      let that = this
      if(that.stocknumchk == '0'){
        that.setLocalStorage( "stocknum", '0')
      }
      if(that.stocknumchk == '1'){
        that.setLocalStorage( "stocknum", '1' )
      }
      that.loadTables(that.page.page, that.page.size, 50)
    },

    /**
     * 加载数据列表
     */
    loadTables: function(_page, _size, _order){
      let that = this
      let _url = that.API_URL + '/v3/price/statistics/paging'
      let _query = {
        skuid: that.$route.params.SkuId,
        channel: that.selectors[0].default,
        authorize: that.selectors[1].default,
        discrepancy: that.selectors[2].default,
        stockNum: that.stocknumchk == 0 ? 0 : 1,
        all: that.lowpricechk,
        search: that.keywords,
        page: _page,
        size: _size,
        order: _order,
        rpstatus: ''
      }
      that.tableloading = true
      $.ajax({
        url: _url,
        type: "GET",
        changeOrigin: true,
        dataType: "json",
        contentType: "application/json",
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""
        },
        data: _query,
        success: function(response) {
					let data = response.results[1]
					that.tableData = that.formatTablefields(data)
					that.pagetotal = response.results[0][0].Count
					that.tableloading = false
          console.log(that.tableData)
        },
        error: function(errors) {
          console.log('loadTables', errors)
        }
			})
    },

  }
}
</script>